import { Injectable } from '@angular/core';
import { AssistantMessage, FormFields, FormMessage } from './models';
import DynamicFormDTO from 'src/app/common/components/dynamic-form-v2/dtos/DynamicFormDTO';
import { InputFieldType } from 'src/app/common/components/dynamic-form-v2/enums/InputFieldType';
import { CommonEntityService } from 'src/app/common/services/common-entity.service';
import { LoggerService } from 'src/app/common/services/logger.service';

export interface AssistantEventHandler {
  (args: any, callback?: (response: any) => void): void | Promise<void>;
}

@Injectable({
  providedIn: 'root',
})
export class AiAssistantService {
  private eventHandlers = new Map<string, AssistantEventHandler[]>();

  constructor(
    private commonEntityService: CommonEntityService,
    private logger: LoggerService
  ) {}

  public registerEventHandler(eventName: string, handler: AssistantEventHandler): void {
    return;
  }

  public unregisterEventHandler(eventName: string, handler: AssistantEventHandler): void {
    const handlers = this.eventHandlers.get(eventName);
    if (handlers) {
      const index = handlers.indexOf(handler);
      if (index > -1) {
        handlers.splice(index, 1);
        if (handlers.length === 0) {
          this.eventHandlers.delete(eventName);
        }
      }
    }
  }

  public getRegisteredEvents(): string[] {
    return Array.from(this.eventHandlers.keys());
  }

  async openChat() {
    return;
  }

  async sendMessage(message: AssistantMessage, sendAuthToken: boolean = true) {
    return;
  }

  async getMetadataForContext(fields: Array<DynamicFormDTO | any>, entity: string, fieldTypesToFilter: InputFieldType[], context: string, isEdit: boolean = false, promptKeys: string[] = []): Promise<any> {
    return null;
  }

  async getChallengeFormMetadata(fields: any, promptKeys: string[] = []): Promise<any> {
    return null;
  }

  public registerDynamicEventHandlers(eventHandlerConfigs: any[], contextParams: any): void {
    return;
  }
}
